// extracted by css-extract-rspack-plugin
export default {"video":"wEAvj","video-fade-in":"lEYN4","videoFadeIn":"lEYN4"};